import { Component, OnInit } from '@angular/core';
import { GetMatchSchedule } from '../../../../graphql/queries';
import { ApiService } from '../../../shared/services/api.service';
import { GetMatchScheduleInput, MatchScheduleType } from '../../../../API';

@Component({
  selector: 'app-match-schedules',
  templateUrl: './match-schedules.component.html',
  styleUrl: './match-schedules.component.scss',
})
export class MatchSchedulesComponent implements OnInit {
  years: number[] = [];
  selectedYear: number = this.years[0];

  markets: string[] = [];
  teams: string[] = [];

  selectedMarket = '';
  selectedTeam = '';

  allMatchSchedules: MatchScheduleType[] = [];
  matchSchedules: MatchScheduleType[] = [];

  loading = false;

  constructor(private apiService: ApiService) {
    this.initYears();
  }

  private initYears(): void {
    const currentYear = new Date().getFullYear();
    this.years = [currentYear, currentYear + 1, currentYear + 2];
    this.selectedYear = currentYear;
  }

  async ngOnInit(): Promise<void> {
    await this.loadYearData(this.selectedYear);
  }

  async fetchMatchSchedule(year: number): Promise<MatchScheduleType[]> {
    const response = await this.apiService.query<
      { GetMatchSchedule: MatchScheduleType[] },
      { input: GetMatchScheduleInput }
    >(GetMatchSchedule, {
      input: { year },
    });

    return response.data?.GetMatchSchedule ?? [];
  }

  async onYearChange(year: number): Promise<void> {
    await this.loadYearData(year);
  }

  private async loadYearData(year: number): Promise<void> {
    this.loading = true;

    try {
      this.selectedYear = year;

      this.allMatchSchedules = await this.fetchMatchSchedule(year);

      this.buildDropdowns(this.allMatchSchedules);
      this.resetFilters();
    } catch (err) {
      console.error('Error loading year data', err);
    } finally {
      this.loading = false;
    }
  }

  private buildDropdowns(matches: MatchScheduleType[]): void {
    this.markets = [...new Set(matches.map((m) => (m.market ?? '').toString()))];

    this.teams = [...new Set(matches.flatMap((m) => [m.team_1, m.team_2]).filter((team): team is string => !!team))];
  }

  onMarketChange(value: string): void {
    this.selectedMarket = value;
    this.applyFilters();
  }

  onTeamChange(value: string): void {
    this.selectedTeam = value;
    this.applyFilters();
  }

  applyFilters(): void {
    const filtered = this.allMatchSchedules.filter((match) => {
      const marketMatch = !this.selectedMarket || match.market === this.selectedMarket;

      const teamMatch = !this.selectedTeam || match.team_1 === this.selectedTeam || match.team_2 === this.selectedTeam;

      return marketMatch && teamMatch;
    });

    this.loadTable(filtered);
  }

  private loadTable(matches: MatchScheduleType[]): void {
    this.matchSchedules = [...matches];
  }

  resetFilters(): void {
    this.selectedMarket = '';
    this.selectedTeam = '';
    this.loadTable(this.allMatchSchedules);
  }

  sortByDate = (a: any, b: any): number => {
    const dateA = new Date(a.match_date).getTime();
    const dateB = new Date(b.match_date).getTime();
    return dateA - dateB;
  };
}
